import { get } from 'services/http';

const fetchResource = uri => {
  return get(`/knowledge-graph/resources/${encodeURIComponent(uri)}`, { addKgId: true });
};

export default { fetchResource };
